var lib_core = require("lib-core");

var PackageGenerationManagerStateMachine = function (root, generatorStateMachine) {
    var self = this;

    lib_core.StateMachine.call(self);
    this.generatorStateMachine = generatorStateMachine;

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.PRECHECK_BEFORE_VERSION_CREATION;
        },
        function(cEvent){
            self.generatorStateMachine.handlePrecheck(cEvent);
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.HIDE_WARNING_POPUP_UNFINISHED_UPDATE_PREVIEW;
        },
        
        function(cEvent){
           self.generatorStateMachine.model.showWarningPopupForUnfinishedPackageUpdatePreview(false);
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.HIDE_WARNING_POPUP_FINISH_GENERATION;
        },
        
        function(cEvent){
            self.generatorStateMachine.model.showWarningPopupForFinishingGeneration(false);
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.HIDE_WARNING_POPUP_PACKAGE_OVERWRITING;
        },
        
        function(cEvent){
           self.generatorStateMachine.handleHideWarningPackageOverwriting();
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.HIDE_WARNING_POPUP_OPEN_FORKED_PACKAGE;
        },
        
        function(cEvent){
            self.generatorStateMachine.model.showWarningPopupForOpeningForkedPackage(false);
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.OVERWRITE_PACKAGE;
        },
        function(cEvent){
            //clear assets in persistent data
            self.generatorStateMachine.handleOverwritePackage();
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.OVERRIDE_PACKAGE_SETTINGS;
        },
        function(cEvent){
            self.generatorStateMachine.handleOverridePackageSettings(cEvent);
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.FINISH_PACKAGE_VERSION_CREATION;
        },
        function(cEvent){
            self.generatorStateMachine.handleFinishVersionCreation();
        }
    );

};

lib_core.inherit(PackageGenerationManagerStateMachine, lib_core.StateMachine);

module.exports = PackageGenerationManagerStateMachine;

